/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartitionValueFilter } from './partitionValueFilter';


export interface BusinessObjectDataDdl { 
    namespace: string;
    businessObjectDefinitionName: string;
    businessObjectFormatUsage: string;
    businessObjectFormatFileType: string;
    businessObjectFormatVersion?: number;
    partitionValueFilters?: Array<PartitionValueFilter>;
    partitionValueFilter?: PartitionValueFilter;
    businessObjectDataVersion?: number;
    /**
     * A Business Object Data Status value specified in the request for available Business Object Data
     */
    businessObjectDataStatus?: string;
    storageNames?: Array<string>;
    storageName?: string;
    outputFormat: BusinessObjectDataDdl.OutputFormatEnum;
    tableName: string;
    customDdlName?: string;
    ddl: string;
    asOfTime?: Date;
}
export namespace BusinessObjectDataDdl {
    export type OutputFormatEnum = 'HIVE_13_DDL';
    export const OutputFormatEnum = {
        HIVE13DDL: 'HIVE_13_DDL' as OutputFormatEnum
    };
}
